import React, {PropsWithChildren} from "react";
import "./FormControl.css";

interface Props {

}

/**
 * Provides styling for a "form control". This is a label and an input.
 * Example usage:
 * ```
 *   <FormControl>
 *     <label htmlFor="firstName">First name</label>
 *     <input name="firstName" type="text"/>
 *   </FormControl>
 * ```
 */
export const FormControl = ({children}: PropsWithChildren<Props>) => {
  return (
      <div className="form-control">
        {children}
      </div>
  )
}